import React, { useState } from 'react'
import { PersonForm, Person } from '../components/person-form'
import { ContactPersonForm, ContactPerson } from '../components/contact-form'
import { ServiceGiver, ServiceGiverForm } from '../components/service-giver-form'
import { makeStyles } from '@material-ui/core/styles'
import { ConfirmModal } from '../components/confirm-modal'
import { ButtonBar } from '../components/ButtonBar'
import { NurseForm, Nurse } from '../components/nurse-form'
 
const useStyles = makeStyles({
  bottomBar: {
    top: 'auto',
    bottom: 5,
    position: 'fixed',
    height: 50,
    display: 'flex',
    alignContent: 'center',
    width: '70vw',
    padding: 5
  },
  content: {
    marginBottom: 120
  },
  returnUrl: {
    alignSelf: 'end',
    float: 'left'
  },
  grow: {
    flex: 1
  },
  noLink: {
    textDecoration: 'none',
    color: 'white'
  }
})

export interface NurseFullFormProps {
  returnUrl: string;
}

export const NurseFullForm: React.FC<NurseFullFormProps> = function (props) {
  const styles = useStyles()
  const [person, setPerson] = useState<Person>({
    personalInfo: {
      firstName: '',
      lastName: '',
      dateOfBirth: new Date(),
      pesel: ''
    },
    addressInfo: {
      house: '',
      street: '',
      postalAndCity: ''
    },
    phone: {}
  })

  const [careGiver1, setCareGiver1] = useState<ContactPerson>({
    personalInfo: {
      firstName: '',
      lastName: '',
      phone: ''
    },
    addressInfo: {
      house: '',
      street: '',
      postalAndCity: ''
    }
  })

  const [careGiver2, setCareGiver2] = useState<ContactPerson>({
    personalInfo: {
      firstName: '',
      lastName: '',
      phone: ''
    },
    addressInfo: {
      house: '',
      street: '',
      postalAndCity: ''
    }
  })

  const [serviceGiver, setServiceGiver] = useState<ServiceGiver>({
    address: 'al. Powstańców Wielkopolski 33b 70-111 Szczecin',
    name: 'POZ Pomorzany Sp. z o.o.',
    choice: {
      choiceThisYear: ''
    }
  })

  const [nurse, setNurse] = useState<Nurse>({
    name: 'Alicja Snoch',
    choice: {
      choiceThisYear: ''
    }
  })

  function updateAndUnset (func: any) {
    return function (arg: any) {
      func(arg)
    }
  }

  const [personError, setPersonError] = useState(true)
  const [giverError, setGiverError] = useState(true)
  const [nurseError, setNurseError] = useState(true)

  const formError = personError || giverError || nurseError
  const [disabled, setDisabled] = useState(false)

  const [pdfEntity, setPdfEntity] = useState<{
    person: Person,
    contact1?: ContactPerson;
    contact2?: ContactPerson;
    serviceGiver: ServiceGiver
    nurse: Nurse;
  }>()
  const [showRodo, setShowRodo] = useState(false)
  function onGenerateClick () {
    if (!formError) {
      if (!disabled) {
        setShowRodo(true)
      } else {
        setDisabled(false)
        setPdfEntity(undefined)
      }
    }
  }

  function rodoAgreement (result: boolean) {
    setShowRodo(false)
    if (result) {
      setPdfEntity({
        serviceGiver,
        nurse,
        person,
        contact1: careGiver1,
        contact2: careGiver2, 
      })
      setDisabled(true)
    }
  }

  const [signInDisabled, setSignInDisabled] = useState(true)
  function onDownload () {
    setSignInDisabled(false)
  }

  return (
    <>
      <ConfirmModal show={showRodo} onHide={rodoAgreement} />
      <div className={styles.content}>
        <PersonForm
          disabled={disabled}
          showError
          onErrorChange={setPersonError}
          value={person}
          onChange={updateAndUnset(setPerson)}  
          title="Dane pacjenta"
        />
        <ContactPersonForm
          value={careGiver1}
          disabled={disabled}
          onChange={updateAndUnset(setCareGiver1)}
          title="Dane dotyczące przedstawiciela ustawowego I."
          subtitle="Wypełniamy w przypadku gdy świadczeniobiorcą jest osoba małoletnia lub całkowicie ubezwłasnowolniona (rodzic/opiekun prawny)"
        />
        <ContactPersonForm
          disabled={disabled}
          value={careGiver2}
          onChange={updateAndUnset(setCareGiver2)}
          title="Dane dotyczące przedstawiciela ustawowego II."
          subtitle="Wypełniamy w przypadku gdy świadczeniobiorcą jest osoba małoletnia (drugi rodzic/opiekun prawny)"
        />
        <ServiceGiverForm
          doctor={false}
          showError
          onErrorChange={setGiverError}
          value={serviceGiver}
          onChange={updateAndUnset(setServiceGiver)}
        />
        <NurseForm
          disabled={disabled}
          showError
          onErrorChange={setNurseError}
          value={nurse}
          onChange={updateAndUnset(setNurse)}
        />
      </div>
      <ButtonBar
        downloadDisabled={!pdfEntity}
        onDownload={onDownload}
        edit={disabled}
        generateObject={pdfEntity}
        isDoctor={false}
        onGenerate={onGenerateClick}
        signDisabled={signInDisabled}
        isValid={formError}
      />
    </>
  )
}
